import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "machine",
  "use": "machine-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"machine\"><g fill-rule=\"evenodd\"><path d=\"M.5 9h5v2.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V9h5v8a1 1 0 0 1-1 1h-15a1 1 0 0 1-1-1z\" /><path d=\"M5.5 3h-2V1a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v2h-2v1.5a.5.5 0 0 1-.5.5h-1.5v4.5a.5.5 0 0 1-.5.5H8a.5.5 0 0 1-.5-.5V5H6a.5.5 0 0 1-.5-.5z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol